@if(initialized){
    <h4>Smart Guide</h4>
    <div  *ngFor="let smartGuide of smartGuideList" [ngClass]="['p-3 border-round my-2',smartGuide.bgColor,smartGuide.textColor]">
        <span class="font-bold ">{{ smartGuide.heading }}: </span> {{smartGuide.text}}
    </div>
}

